import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../src/lib/component-base';
import StatusAdvisory from './StatusAdvisory';
import Icon from '../../../../../../src/components/lib/Icon';
import { openTab } from '../../../../../../src/utils/openTab';

const AABadge = '//assets.flightstats.com/v2/AA-Badge.svg';
const AALink = 'https://www.aa.com/i18n/customer-service/about-us/about-us.jsp#datapartners';

@componentBase('FlightHeader')
export default class FlightHeader extends React.Component {
  static propTypes = {
    carrier: PropTypes.object,
    color: PropTypes.string,
    statusDescription: PropTypes.string,
    flightNumber: PropTypes.string,
    status: PropTypes.string,
    diverted: PropTypes.bool,
    advisoryDisplayStatus: PropTypes.string,
  };

  static defaultProps = {
    carrier: { fs: null, name: null },
    color: null,
    statusDescription: null,
    flightNumber: null,
    status: null,
    redirected: false,
    diverted: false,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      headerStyle: {
        padding: '10px 20px',
        minHeight: '35px',
        display: 'block',
        borderBottom: '5px solid rgb(250, 167, 24)',
      },
      flightTitleStyle: {
        marginRight: '10px',
        display: 'inline-block',
        fontSize: '20pt',
        fontWeight: 'bold',
        lineHeight: '25px',
      },
      statusTextStyle: {
        display: 'inline-block',
        fontSize: '20pt',
        margin: '5px 0',
        textAlign: 'center',
        lineHeight: '20pt',
        padding: '5px 30px',
        minWidth: '150px',
      },
      maxHeight: 700,
      autoWidth: true,
    };
  }

  openAALink = (e) => {
    this.context.reportButtonPress('FlightTrackerAAPartnerBadge');
    openTab(AALink, e);
  }

  render() {
    let statusWording = this.props.status;

    if (this.props.diverted && this.props.statusDescription) {
      statusWording = `${statusWording} | ${this.props.statusDescription}`;
    } else if (this.props.status !== 'Cancelled' && this.props.status !== 'Unknown' && this.props.statusDescription) {
      statusWording = `${this.props.statusDescription} | ${statusWording}`;
    }

    const statusWordingElement = (<p className={`flight-status-box ${this.props.color}`} style={this.muiDefaultProps.statusTextStyle}>{statusWording}</p>);
    let statusAdvisory;

    if (this.props.carrier) {
      let aaBadge;
      const { carrier } = this.props;

      if (carrier.fs === 'AA') {
        aaBadge = (
          <a href={AALink} onClick={e => this.openAALink(e)}>
            <Icon className='flight-status-aa-badge' src={AABadge} style={{ width: '224px', height: '56px' }} />
          </a>
        );
      }
      if (this.props.advisoryDisplayStatus) {
        statusAdvisory = (<StatusAdvisory {...this.props} />);
      }
      return (
        <div className='flight-status-header'>
          <div style={this.muiDefaultProps.headerStyle}>
            <span style={this.muiDefaultProps.flightTitleStyle}>
              ({carrier.fs}) {carrier.name} {this.props.flightNumber}
            </span>
            {statusWordingElement}
            {aaBadge}
          </div>
          {statusAdvisory}
        </div>
      );
    }
    return (<div />);
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightHeader/FlightHeader.js